import React from "react";

const CopyNumberDeterminationDescription = () => {
  return (
    <div id="assy-creation-description">
      <h2>Assay Description</h2>

      <div>
        <p>
          Bio-Rad’s ddPCR Copy Number Determination Assays offer high precision
          and resolution to discriminate between small changes in copy number.
        </p>
        <p>
          Digital PCR can easily detect small fold changes such as 1.2 fold
          change in CNV from 5 to 6 copies. A major technical challenge in copy
          number assessment is the ability to discriminate, with statistical
          confidence, between consecutive copy number states. Partitioning of
          the ddPCR reaction enables the discrimination required to resolve
          small fold changes.&nbsp;
          <span>
            Browse list of wet-lab validated{" "}
            <a href="/webroot/web/pdf/lsr/literature/Bulletin_7144.pdf">
              Copy Number Determination Assays
            </a>{" "}
            and{" "}
            <a href="/webroot/web/pdf/lsr/literature/Bulletin_7144.pdf">
              Centromeric CNV Assays
            </a>
            .
          </span>
        </p>
        <h3>Key Benefits</h3>
        <ul>
          <li>Wet-lab validated assays available for more than 700 targets</li>
          <li>
            Centromeric reference assays available for more than 60 targets
          </li>
          <li>
            Wet-lab validated assays guaranteed to work when used as instructed
          </li>
          <li>Validation data available for review and download</li>
          <li>
            Assays are designed instantly for targets and sequences for which
            validated assays are not available
          </li>
          <li>Assays orderable in FAM or HEX</li>
          <li>Reference assays available</li>
        </ul>
        <h3>Sample Data</h3>
        <br />
        <img
          src="//www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/6512-CND-A.jpg"
          alt="6512-CND-A"
          width="630"
          height="329"
          caption="false"
        />
        <br />
        <img
          src="//www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/6512-CND-B.jpg"
          alt="6512-CND-B"
          width="630"
          height="329"
          caption="false"
        />
        <br />
        <img
          src="//www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/6512-CND-C.jpg"
          alt="6512-CND-C"
          width="630"
          height="329"
          caption="false"
        />
        <p>
          <small>
            <strong>
              PrimePCR ddPCR copy number assays provide superior resolution and
              precision. A
            </strong>
            , 2-D fluorescence amplitude plot shows four replicate wells of a
            copy number sample duplexed with <em>ERBB2</em> and <em>RPP30</em>{" "}
            assays. The black cluster on the plot represents the negative
            droplets, the green cluster represents the droplets that are
            positive for
            <em>RPP30</em> reference only, the blue cluster represents the
            droplets that are positive for <em>ERBB2</em> only, and the orange
            cluster represents the droplets that are positive for both{" "}
            <em>ERBB2</em> and
            <em>RPP30</em> targets. <strong>B</strong>, copy number plot shows
            multiple wells at copy number 2 with precise replicate and merged
            well values. <strong>C</strong>, copy number plot shows multiple
            oncogene copy number determinations for various genes with the same
            NCI-H358 lung cancer sample. All error bars are generated by
            QuantaSoft software and represent the 95% confidence interval.
          </small>
        </p>
        <h3>Packaging Options</h3>
        <p>
          ddPCR Copy Number Determination Assays are available with FAM or HEX.
          <br />
          The ddPCR CNV Assays are provided in a 20X, ready-to-use primer-probe
          mix optimized for use with ddPCR Supermix for Probes (No dUTP). Each
          tube contains 18uM primers and 5uM probe.
        </p>
      </div>
    </div>
  );
};

export default CopyNumberDeterminationDescription;
